import { usePunditUserContext } from "@circle-react/contexts";

export const useIsWorkflowExecutionEnabled = () => {
  const { currentCommunity } = usePunditUserContext();

  return Boolean(currentCommunity?.workflow_execution_enabled);
};
